//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// responsive
import { M, T } from "../../utils/MT";

// component
import Header from "../../component/common/Header";
import ProductDetail from "./components/ProductDetail";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

export default function ProductDetailPage() {
    return (
        <Wrap>
            <Header />
            <InnerCon>
                <ProductDetail />
            </InnerCon>
            <Footer />
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
